// TODO: Might as well change to func comp.
/* eslint-disable react/state-in-constructor */
/* eslint-disable react/static-property-placement */
/* eslint-disable react/sort-comp */
import React, { Component } from "react";
import { bool, number, object, string } from "prop-types";

export const DEFAULT_SCOPE = "default";
export const UPDATE_TIME = 400;
export const MAX_PROGRESS = 100;
export const PROGRESS_INCREASE = 20;
export const ANIMATION_DURATION = UPDATE_TIME * 2;
export const TERMINATING_ANIMATION_DURATION = UPDATE_TIME / 2;

const initialState = {
  percent: 0,
  status: "hidden",
};

class LoadingBar extends Component {
  static propTypes = {
    className: string,
    maxProgress: number,
    progressIncrease: number,
    showFastActions: bool,
    updateTime: number,
    style: object,
  };

  static defaultProps = {
    className: "",
    maxProgress: MAX_PROGRESS,
    progressIncrease: PROGRESS_INCREASE,
    showFastActions: false,
    style: {},
    updateTime: UPDATE_TIME,
  };

  static shouldStart(props, state) {
    return props.loading && ["hidden", "stopping"].indexOf(state.status) >= 0;
  }

  static shouldStop(props, state) {
    return !props.loading && ["starting", "running"].indexOf(state.status) >= 0;
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (LoadingBar.shouldStart(nextProps, prevState)) {
      return { status: "starting" };
    }

    if (LoadingBar.shouldStop(nextProps, prevState)) {
      return { status: "stopping" };
    }

    return null;
  }

  state = { ...initialState };

  componentDidMount() {
    const { status } = this.state;
    if (status === "starting") {
      this.start();
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { status } = this.state;
    if (prevState.status !== status) {
      if (status === "starting") {
        this.start();
      }

      if (status === "stopping") {
        this.stop();
      }
    }
  }

  componentWillUnmount() {
    clearInterval(this.progressIntervalId);
    clearTimeout(this.terminatingAnimationTimeoutId);
  }

  reset = () => {
    this.terminatingAnimationTimeoutId = null;
    this.setState(initialState);
  };

  newPercent = (percent, progressIncrease) => {
    // Use cosine as a smoothing function
    // It could be any function to slow down progress near the ending 100%
    const smoothedProgressIncrease =
      progressIncrease * Math.cos(percent * (Math.PI / 2 / 100));

    return percent + smoothedProgressIncrease;
  };

  simulateProgress = () => {
    this.setState((prevState, { maxProgress, progressIncrease }) => {
      let { percent } = prevState;
      const newPercent = this.newPercent(percent, progressIncrease);

      if (newPercent <= maxProgress) {
        percent = newPercent;
      }

      return { percent };
    });
  };

  stop() {
    const { showFastActions } = this.props;
    clearInterval(this.progressIntervalId);
    this.progressIntervalId = null;

    const terminatingAnimationDuration =
      this.isShown() || showFastActions ? TERMINATING_ANIMATION_DURATION : 0;

    this.terminatingAnimationTimeoutId = setTimeout(
      this.reset,
      terminatingAnimationDuration
    );

    this.setState({ percent: 100 });
  }

  start() {
    const { updateTime } = this.props;
    this.progressIntervalId = setInterval(this.simulateProgress, updateTime);
    this.setState({ status: "running" });
  }

  isShown() {
    const { percent } = this.state;
    return percent > 0 && percent <= 100;
  }

  buildStyle() {
    const { status, percent } = this.state;
    const { className, style: externalStyle } = this.props;

    const animationDuration =
      status === "stopping"
        ? TERMINATING_ANIMATION_DURATION
        : ANIMATION_DURATION;

    const style = {
      zIndex: 99,
      opacity: "1",
      transform: `translate3d(${percent - 100}%, 0px, 0px)`,
      msTransform: `translate3d(${percent - 100}%, 0px, 0px)`,
      WebkitTransform: `translate3d(${percent - 100}%, 0px, 0px)`,
      MozTransform: `translate3d(${percent - 100}%, 0px, 0px)`,
      OTransform: `translate3d(${percent - 100}%, 0px, 0px)`,
      transition: `transform ${animationDuration}ms linear 0s`,
      msTransition: `-ms-transform ${animationDuration}ms linear 0s`,
      WebkitTransition: `-webkit-transform ${animationDuration}ms linear 0s`,
      MozTransition: `-moz-transform ${animationDuration}ms linear 0s`,
      OTransition: `-o-transform ${animationDuration}ms linear 0s`,
      width: "100%",
      willChange: "transform, opacity",
      position: "absolute",
      left: "0px",
      top: "0px",
    };
    // Use default styling if there's no CSS class applied
    if (!className) {
      style.height = "3px";
      style.backgroundColor = "#FF9900";
      style.position = "absolute";
    }

    if (this.isShown()) {
      style.opacity = "1";
    } else {
      style.opacity = "0";
    }

    return { ...style, ...externalStyle };
  }

  render() {
    const { status } = this.state;
    const { className } = this.props;
    if (status === "hidden") {
      return <div data-request-loading-status={status} />;
    }

    return (
      <div data-testid="app-top-loader" data-request-loading-status={status}>
        <div style={this.buildStyle()} className={className} />
        <div style={{ display: "table", clear: "both" }} />
      </div>
    );
  }
}

export default LoadingBar;
